export function getSuggestStatus(currentLength, suggestMinLength) {
  if (currentLength < suggestMinLength && currentLength > 0) {
    return 'warning'
  }
  if (currentLength >= suggestMinLength) {
    return 'success'
  }
}

export function getSuggestStatusText(status, currentLength, suggestMinLength) {
  return status === 'warning'
    ? `${currentLength} ตัวอักษร (${suggestMinLength} ตัวอักษรขึ้นไป)`
    : `${currentLength} ตัวอักษร (ต่ำสุด ${suggestMinLength})`
}



// WEBPACK FOOTER //
// ./src/components/views/widgets/inputUtils.js